import firebase from 'firebase';
import "firebase/firestore";
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCWQViLXBWuSqihX17GKCQC9kIRoNvXkuE",
    authDomain: "word-by-word-70ccf.firebaseapp.com",
    databaseURL: "https://word-by-word-70ccf.firebaseio.com",
    projectId: "word-by-word-70ccf",
    storageBucket: "word-by-word-70ccf.appspot.com",
    messagingSenderId: "740385051634",
    appId: "1:740385051634:web:6ed58b109faa2e88"
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();

const settings = {
    timestampsInSnapshots: true
};

firestore.settings(settings);
export default firebase;





// WEBPACK FOOTER //
// ./src/app/common/config/firebase.js